import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import PropertyTypeService from "../../services/propertyType.service";


export const postpropertyType = createAsyncThunk(
  "propertyType/addpropertyType",
  async (item, thunkAPI) => {
    try {
      const response = await PropertyTypeService.addPropertyType(item);
      return response.data; // Return actual data
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getpropertyType = createAsyncThunk(
  "propertyType/getpropertyType",
  async (item, thunkAPI) => {
    try {
      const response = await PropertyTypeService.getPropertyType(item);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const putpropertyType = createAsyncThunk(
  "propertyType/editpropertyType",
  async (item, thunkAPI) => {
    try {
      const response = await PropertyTypeService.editPropertyType(item);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const deletepropertyType = createAsyncThunk(
  "propertyType/deletepropertyType",
  async (id, thunkAPI) => {
    try {
      await PropertyTypeService.deletePropertyType(id);
      return id; // Return only the ID to remove it from state
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// **Initial State**
const initialState = {
  loading: false,
  error: "",
  propertyTypes: [],
};

// **Slice**
const propertyTypeSlice = createSlice({
  name: "propertyType",
  initialState,
  extraReducers: (builder) => {
    builder
      // **Handle Get Property Types**
      .addCase(getpropertyType.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(getpropertyType.fulfilled, (state, action) => {
        state.loading = false;
        state.propertyTypes = action.payload;
      })
      .addCase(getpropertyType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // **Handle Add Property Type**
      .addCase(postpropertyType.pending, (state) => {
        state.loading = true;
      })
      .addCase(postpropertyType.fulfilled, (state, action) => {
        state.loading = false;
        state.propertyTypes.push(action.payload);
      })
      .addCase(postpropertyType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // **Handle Edit Property Type**
      .addCase(putpropertyType.pending, (state) => {
        state.loading = true;
      })
      .addCase(putpropertyType.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.propertyTypes.findIndex((pt) => pt.id === action.payload.id);
        if (index !== -1) {
          state.propertyTypes[index] = action.payload;
        }
      })
      .addCase(putpropertyType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // **Handle Delete Property Type**
      .addCase(deletepropertyType.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletepropertyType.fulfilled, (state, action) => {
        state.loading = false;
        state.propertyTypes = state.propertyTypes.filter((pt) => pt.id !== action.payload);
      })
      .addCase(deletepropertyType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});


export default propertyTypeSlice.reducer;
